/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/allas/components/standalone/ArticleTeaser/Default/theme';

export const ArticleTeaserDefaultTheme = theme;
